import { get } from 'lodash';
import { createSelector } from 'reselect';
export const getWixData = (state) => state.wixData;
export const getWixDataCategoryId = createSelector([getWixData], (wixData) => get(wixData, 'categoryId', null));
export const getWixDataTagId = createSelector([getWixData], (wixData) => get(wixData, 'tagId', null));
//# sourceMappingURL=get-wix-data.js.map